export default function normalizeFlatShipmentItems(items = []) {
  return items.map((item) => ({
    id: item.id,
    shipment_item_id: item.id,
    barcode: item.barcode,
    lot_number: item.lot_number,
    packing_size: item.packing_size,
    packaging_date: item.picked_at,
    case_quantity: item.case_quantity ?? 0,
    carton_type: item.carton_type,
    product_id: item.product_id,
    product_name: item.product_name,
    plu: item.plu,
    serial_number: item.serial_number,
    status: item.status,
    return_status: item.return_status,
    credit_status: item.credit_status,
    description_en: item.description_en ?? item.description,
    product_temperature: item.product_temperature,
    order_item_id: item.order_item_id,
    is_quick_scan: item.is_quick_scan ?? false,
  }));
}
